<template>
  <SkeletonLoader>
    <div class="pp-skeleton">
      <!-- Header -->
      <div class="pp-skeleton__header">
        <div class="sk-rect pp-skeleton__title"></div>
        <div class="pp-skeleton__header-icons">
          <div class="sk-circle sk-circle--sm"></div>
          <div class="sk-circle sk-circle--sm"></div>
        </div>
      </div>

      <!-- Mobile: single column (check-in + 1 operatory) -->
      <div class="pp-skeleton__mobile">
        <div class="pp-skeleton__column pp-skeleton__column--narrow">
          <div class="pp-skeleton__column-header">
            <div class="sk-line" style="width: 70px"></div>
          </div>
          <div
            v-for="card in mobileCheckin"
            :key="card.id"
            class="pp-skeleton__card"
          >
            <div class="pp-skeleton__card-row">
              <div class="sk-circle sk-circle--md"></div>
              <div class="pp-skeleton__card-lines">
                <div class="sk-line" :style="{ width: card.nameWidth }"></div>
                <div class="sk-line sk-line--sm" :style="{ width: card.statusWidth }"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="pp-skeleton__column">
          <div class="pp-skeleton__column-header">
            <div class="sk-line" style="width: 90px"></div>
          </div>
          <div
            v-for="card in mobileOp"
            :key="card.id"
            class="pp-skeleton__card"
          >
            <div class="pp-skeleton__card-row">
              <div class="sk-circle sk-circle--md"></div>
              <div class="pp-skeleton__card-lines">
                <div class="sk-line" :style="{ width: card.nameWidth }"></div>
                <div class="sk-line sk-line--sm" :style="{ width: card.statusWidth }"></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Tablet: 3 columns -->
      <div class="pp-skeleton__tablet">
        <div
          v-for="col in tabletColumns"
          :key="col.id"
          class="pp-skeleton__column"
          :class="{ 'pp-skeleton__column--narrow': col.narrow }"
        >
          <div class="pp-skeleton__column-header">
            <div class="sk-line" :style="{ width: col.nameWidth }"></div>
          </div>
          <div
            v-for="card in col.cards"
            :key="card.id"
            class="pp-skeleton__card"
          >
            <div class="pp-skeleton__card-row">
              <div class="sk-circle sk-circle--md"></div>
              <div class="pp-skeleton__card-lines">
                <div class="sk-line" :style="{ width: card.nameWidth }"></div>
                <div class="sk-line sk-line--sm" :style="{ width: card.statusWidth }"></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Desktop: full board -->
      <div class="pp-skeleton__board">
        <div
          v-for="col in columns"
          :key="col.id"
          class="pp-skeleton__column"
          :class="{ 'pp-skeleton__column--narrow': col.narrow }"
        >
          <div class="pp-skeleton__column-header">
            <div class="sk-line" :style="{ width: col.nameWidth }"></div>
          </div>
          <div
            v-for="card in col.cards"
            :key="card.id"
            class="pp-skeleton__card"
          >
            <div class="pp-skeleton__card-row">
              <div class="sk-circle sk-circle--md"></div>
              <div class="pp-skeleton__card-lines">
                <div class="sk-line" :style="{ width: card.nameWidth }"></div>
                <div class="sk-line sk-line--sm" :style="{ width: card.statusWidth }"></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Bottom: chat area placeholder -->
      <div class="pp-skeleton__chat">
        <div class="sk-rect pp-skeleton__chat-rect"></div>
      </div>
    </div>
  </SkeletonLoader>
</template>

<script>
import SkeletonLoader from '@/components/SkeletonLoader.vue'

export default {
  name: 'PracticePulseSkeleton',
  components: { SkeletonLoader },
  data () {
    return {
      mobileCheckin: [
        { id: 'mc-1', nameWidth: '75%', statusWidth: '50%' },
        { id: 'mc-2', nameWidth: '60%', statusWidth: '65%' }
      ],
      mobileOp: [
        { id: 'mo-1', nameWidth: '70%', statusWidth: '55%' },
        { id: 'mo-2', nameWidth: '80%', statusWidth: '45%' },
        { id: 'mo-3', nameWidth: '65%', statusWidth: '60%' }
      ],
      tabletColumns: [
        {
          id: 'tab-checkin',
          nameWidth: '70px',
          narrow: true,
          cards: [
            { id: 'tc-1', nameWidth: '75%', statusWidth: '50%' },
            { id: 'tc-2', nameWidth: '60%', statusWidth: '65%' }
          ]
        },
        {
          id: 'tab-op1',
          nameWidth: '90px',
          narrow: false,
          cards: [
            { id: 'to1-1', nameWidth: '70%', statusWidth: '55%' },
            { id: 'to1-2', nameWidth: '80%', statusWidth: '45%' }
          ]
        },
        {
          id: 'tab-checkout',
          nameWidth: '80px',
          narrow: true,
          cards: [
            { id: 'tco-1', nameWidth: '65%', statusWidth: '60%' }
          ]
        }
      ],
      columns: [
        {
          id: 'checkin',
          nameWidth: '70px',
          narrow: true,
          cards: [
            { id: 'ci-1', nameWidth: '75%', statusWidth: '50%' },
            { id: 'ci-2', nameWidth: '60%', statusWidth: '65%' }
          ]
        },
        {
          id: 'op-1',
          nameWidth: '90px',
          narrow: false,
          cards: [
            { id: 'o1-1', nameWidth: '70%', statusWidth: '55%' },
            { id: 'o1-2', nameWidth: '80%', statusWidth: '45%' },
            { id: 'o1-3', nameWidth: '65%', statusWidth: '60%' }
          ]
        },
        {
          id: 'op-2',
          nameWidth: '100px',
          narrow: false,
          cards: [
            { id: 'o2-1', nameWidth: '72%', statusWidth: '48%' },
            { id: 'o2-2', nameWidth: '58%', statusWidth: '62%' }
          ]
        },
        {
          id: 'op-3',
          nameWidth: '80px',
          narrow: false,
          cards: [
            { id: 'o3-1', nameWidth: '68%', statusWidth: '52%' },
            { id: 'o3-2', nameWidth: '76%', statusWidth: '42%' },
            { id: 'o3-3', nameWidth: '62%', statusWidth: '58%' }
          ]
        },
        {
          id: 'op-4',
          nameWidth: '95px',
          narrow: false,
          cards: [
            { id: 'o4-1', nameWidth: '74%', statusWidth: '50%' },
            { id: 'o4-2', nameWidth: '66%', statusWidth: '56%' }
          ]
        },
        {
          id: 'checkout',
          nameWidth: '80px',
          narrow: true,
          cards: [
            { id: 'co-1', nameWidth: '65%', statusWidth: '60%' }
          ]
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.pp-skeleton {
  padding: 16px;

  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 24px;
  }

  &__title {
    width: 180px;
    height: 28px;
  }

  &__header-icons {
    display: flex;
    gap: 12px;
  }

  &__mobile {
    display: none;
  }

  &__tablet {
    display: none;
  }

  &__board {
    display: flex;
    gap: 12px;
    min-height: 500px;
    align-items: flex-start;
  }

  &__column {
    flex: 1;
    min-width: 0;
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    padding: 12px;

    &--narrow {
      flex: 0.6;
    }
  }

  &__column-header {
    display: flex;
    align-items: center;
    margin-bottom: 12px;
    padding-bottom: 8px;
    border-bottom: 2px dashed #e2e8f0;

    .sk-line {
      margin-bottom: 0;
    }
  }

  &__card {
    background: #fff;
    border-radius: 6px;
    padding: 10px 12px;
    margin-bottom: 10px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);

    &:last-child {
      margin-bottom: 0;
    }
  }

  &__card-row {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  &__card-lines {
    flex: 1;
    min-width: 0;

    .sk-line {
      margin-bottom: 6px;

      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  &__chat {
    margin-top: 24px;
  }

  &__chat-rect {
    width: 100%;
    height: 80px;
    border-radius: 8px;
  }
}

/* Tablet: 769px - 1024px */
@media (min-width: 769px) and (max-width: 1024px) {
  .pp-skeleton {
    &__board {
      display: none;
    }

    &__tablet {
      display: flex;
      gap: 12px;
      min-height: 400px;
      align-items: flex-start;
    }
  }
}

/* Mobile: up to 768px */
@media (max-width: 768px) {
  .pp-skeleton {
    &__board {
      display: none;
    }

    &__mobile {
      display: flex;
      flex-direction: column;
      gap: 16px;
    }

    &__column {
      flex: none;
      width: 100%;
    }

    &__title {
      width: 140px;
    }
  }
}
</style>
